<template>
    <div>
        <Message sticky :closable="false">
            <div class="text-xl mb-3">
                We found <b>{{ props.message }}</b> matching your following criterias. To refine your results further you may add additional criteria.
            </div>
            <div v-if="contentAvailable">
                <table class="styled-table">
                    <thead>
                        <tr>
                            <th>Filters</th>
                            <th>Values</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(value, key) in content" :key="key">
                            <td class="font-bold font-italic">{{ key }}</td>
                            <td>{{ value }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Message>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    message: {
        type: String,
        required: true,
    },
    content: {
        type: Object,
    },
});

const contentAvailable = computed(() => {
    return props.content && Object.keys(props.content).length !== 0;
});
</script>

<style>
.styled-table {
    border-collapse: collapse;
    width: 100%;
    border: 1px solid #000; /* Add your preferred border color */
}

.styled-table th,
.styled-table td {
    border: 1px solid #000; /* Add your preferred border color */
    padding: 8px;
    text-align: left;
}
</style>
